/**
 * 製品テンプレートTOP: ナビ（高さ）
 * .ist-productsTop__nav.ist-pc が存在する場合
 * :root の css 変数 --ist-productsNavHeight に設定
 *
 * .ist-mb .ist-productsTop__navTitle が存在する場合
 * :root の css 変数 --ist-productsTopNavTitleSp を設定
 */
class ProductsNavHeight {
  private root: HTMLElement;
  private pcNav: HTMLElement | null;
  private spNavTitle: HTMLElement | null;
  private resizeObserver: ResizeObserver;

  constructor() {
    this.root = document.documentElement;
    this.pcNav = document.querySelector('.ist-productsTop__nav.ist-pc');
    this.spNavTitle = document.querySelector(
      '.ist-mb .ist-productsTop__navTitle'
    );
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height = entry.borderBoxSize[0].blockSize;
        const target = entry.target;

        if (target === this.pcNav) {
          this.updatePcNavHeight(height);
        } else if (target === this.spNavTitle) {
          this.updateSpNavTitleHeight(height);
        }
      }
    });
    this.init();
  }

  private init(): void {
    if (this.pcNav) {
      this.resizeObserver.observe(this.pcNav);
      this.updatePcNavHeight(this.pcNav.getBoundingClientRect().height);
    }

    if (this.spNavTitle) {
      this.resizeObserver.observe(this.spNavTitle);
      this.updateSpNavTitleHeight(
        this.spNavTitle.getBoundingClientRect().height
      );
    }
  }

  private updatePcNavHeight(height: number): void {
    if (!height) return;
    const heightValue = height.toFixed(4);
    this.root.style.setProperty('--ist-productsNavHeight', `${heightValue}px`);
  }

  private updateSpNavTitleHeight(height: number): void {
    if (!height) return;
    const heightValue = height.toFixed(4);
    this.root.style.setProperty(
      '--ist-productsTopNavTitleSp',
      `${heightValue}px`
    );
  }

  public destroy(): void {
    if (this.pcNav) {
      this.resizeObserver.unobserve(this.pcNav);
    }
    if (this.spNavTitle) {
      this.resizeObserver.unobserve(this.spNavTitle);
    }
    this.resizeObserver.disconnect();
  }
}

export default ProductsNavHeight;
